import { ExtBase, ForeignKey, User, Base } from "../../../core/db/models/index";
import Order, { OrderLike } from "./order";
import ValtasiirtoDatabase from "../index";
import { OrderAssignmentBase } from "./index";

export interface OrderAssignmentLike extends OrderAssignmentBase
{
    order_id: ForeignKey<OrderLike>;
    is_master: boolean;
    order?: OrderLike;
}

export default class OrderAssignment implements OrderAssignmentLike
{
    order_id: ForeignKey<OrderLike>;
    is_master: boolean;
    order?: OrderLike;
    start_time: string;
    end_time: string;
    user_id: ForeignKey<User>;
    user?: User;
    extra_info: string;
    created_at?: string;
    modified_at?: string;
    id?: number;

    public static withAll(db: ValtasiirtoDatabase, targetAssignments: OrderAssignmentLike[] | Dexie.Collection<OrderAssignmentLike, any>): PromiseLike<OrderAssignmentLike[]>
    {
        let assignments: OrderAssignmentLike[];

        return new Promise<OrderAssignmentLike[]>((resolve, reject) =>
        {
            if (Array.isArray(targetAssignments))
            {
                return resolve(targetAssignments);
            }
            else
            {
                return targetAssignments.toArray().then(resolve);
            }
        }).then((assignmentList) =>
        {   
            assignments = assignmentList;
            let assignmentIds = assignments.map(o => o.id);
            let userIds = assignments.map(o => o.user_id) as number[];

            return Promise.all([
                db.User.where('id').anyOf(userIds).toArray(),
            ])
        }).then((results) =>
        {
            let users = results[0];

            for(let assignment of assignments)
            {
                assignment.user = users.find(o => o.id == assignment.user_id);
            }

            return assignments;
        });
    }
}